/** Rollen conform docs/PRD.md. Bewust identiek aan de Prisma-enum `Role`. */
export const ROLES = ['VIEWER', 'ANALYST', 'ADMIN', 'AUDITOR'];
/** Nederlandstalige labels voor de interface. */
export const ROLE_LABELS = {
    VIEWER: 'Kijker',
    ANALYST: 'Analist',
    ADMIN: 'Beheerder',
    AUDITOR: 'Auditor',
};
/** Rol die een nieuwe medewerker zonder toegewezen rechten krijgt. */
export const DEFAULT_ROLE = 'VIEWER';
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** Mag deze rol analyses starten, corrigeren en bevestigen? */
export function canRunAnalyses(role) {
    return role === 'ANALYST' || role === 'ADMIN';
}
//# sourceMappingURL=roles.js.map